import { useState, type FormEvent } from "react";
import { WarningCircleIcon } from "@phosphor-icons/react";
import { readableError, signIn } from "../lib/pb.ts";
import { Button } from "../components/ui.tsx";

export function Login() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);

  async function submit(event: FormEvent) {
    event.preventDefault();
    setBusy(true);
    setError(null);
    try {
      await signIn(email.trim(), password);
      // App re-renders from the auth store change; nothing to do here.
    } catch (cause) {
      setError(readableError(cause));
      setBusy(false);
    }
  }

  return (
    <main className="login">
      <div className="login__card">
        <div className="login__brand">
          <span className="brand__mark" aria-hidden="true">
            P
          </span>
          <div>
            <h1 className="login__title">Pipeline Console</h1>
            <p className="login__sub">Lead operations</p>
          </div>
        </div>

        <form className="login__form" onSubmit={submit} noValidate>
          <div className="field">
            <label className="field__label" htmlFor="email">
              Email
            </label>
            <input
              id="email"
              className="input"
              type="email"
              autoComplete="username"
              autoFocus
              required
              value={email}
              aria-invalid={error ? true : undefined}
              onChange={(event) => setEmail(event.target.value)}
            />
          </div>

          <div className="field">
            <label className="field__label" htmlFor="password">
              Password
            </label>
            <input
              id="password"
              className="input"
              type="password"
              autoComplete="current-password"
              required
              value={password}
              aria-invalid={error ? true : undefined}
              onChange={(event) => setPassword(event.target.value)}
            />
          </div>

          {/* Inline, below the fields, tied to the inputs by aria-invalid. */}
          {error && (
            <p className="field__error" role="alert">
              <WarningCircleIcon size={14} weight="fill" aria-hidden="true" />
              {error}
            </p>
          )}

          <Button type="submit" variant="primary" block loading={busy}>
            {busy ? "Signing in" : "Sign in"}
          </Button>
        </form>
      </div>
    </main>
  );
}
